export default function () {
    const self = this,
        quantity = self.profileFinder.query.quantity

    for (let i = 0; i < quantity; i++) {
        if (!self.profileFinder.profiles[i]) {
            self.$store.commit('setProfileSearchProfile', {
                index: i,
                profile: {}
            })
        }
    }
}
